/* istanbul ignore file */
import makeApi from '@lib/api'

interface CreatePaymentSessionRequest {
  payment_provider: string
  shopper_country_code?: string
  api_key?: string
}

interface CreatePaymentSessionResponse {
  id: string
  payment_session_secret: string
  payment_session_token: string
  _links: {
    self: {
      href: string
    }
  }
  [key: string]: any
}

const createPaymentSession = async (data: CreatePaymentSessionRequest): Promise<CreatePaymentSessionResponse> => {
  const callApi = makeApi.post<{}, CreatePaymentSessionRequest, CreatePaymentSessionResponse>('/payments/sessions')

  return await callApi({ params: {}, body: data })
}

const checkoutComApi = {
  createPaymentSession,
}

export default checkoutComApi
